import { render, staticRenderFns } from "./ChoiceFields.vue?vue&type=template&id=609b84ac&scoped=true&"
import script from "./ChoiceFields.vue?vue&type=script&lang=js&"
export * from "./ChoiceFields.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceFields.vue?vue&type=style&index=0&id=609b84ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b84ac",
  null
  
)

export default component.exports